import getHelper from '../../../services/getHelper';

import PresentationSessionCancelation from '../types/PresentationSessionCancelation';

export default getHelper('/presentation-sessions/:id', {
  projectSession: getHelper('/project-session'),
  cancel: getHelper<PresentationSessionCancelation>('/cancel'),
  complete: getHelper('/complete'),
});
